import {createAction} from '@reduxjs/toolkit';
import {beerStylesNamespace} from 'store/beerStyles/beerStyleSlice';
import {UpdateProfileDTO} from 'typescript/dto/updateProfileDto';
import {withPayloadType} from 'typescript/types/PayloadType';

const updateUserInfoACS = createAction(`${beerStylesNamespace}/updateUserInfoACS`, withPayloadType<UpdateProfileDTO>());

export {updateUserInfoACS};
